import React, { useState } from "react";
import { Nav, TabContent } from 'reactstrap';
import List from "./PurchaseOrders/List2";
import ListBills from "./Bills/ListBills";
import ListCreditNotes from "../AccountsReceivable/ListCreditNotes"
import Repeating from "../AccountsReceivable/Repeating";
import { Switch, Redirect } from "react-router-dom";
import { Page, NavItem, TabPane } from "components/common";

export * as CreditNotes from "../AccountsReceivable/ListCreditNotes";
export * as PurchaseOrders from "./PurchaseOrders";
export * as Bills from "./Bills";

export const Landing = ({ match }) => {

  return (
    <Page className='inv-tabs'>
      <div>
        <Nav tabs className="mb-2">
          <NavItem to={`/purchases/bills`}>
            Bills
          </NavItem>
          <NavItem to={`/purchases/credit_notes`}>
            Credit Notes
          </NavItem>
          <NavItem to={`/purchases/purchase_orders`}>
            Purchase orders
          </NavItem>
          <NavItem to={`/purchases/repeating`}>
            Repeating Bills
          </NavItem>
        </Nav>
        <TabContent>
          <Switch>
            <TabPane path={`/purchases/bills`} component={ListBills} match={match} exact={false} />
            <TabPane path={`/purchases/credit_notes`} component={ListCreditNotes} match={match} exact={false} />
            <TabPane path={`/purchases/purchase_orders`} component={List} match={match} exact={false} />
            <TabPane path={`/purchases/repeating`} component={Repeating} match={match} exact={false} />
            <Redirect to={`/purchases/bills`} />
          </Switch>
        </TabContent>
      </div>
    </Page>
  );
}
